import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningCustomisationsSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemViewCustomisation = (props) => {
  const { selectedItem } = props;
  const [loading, setLoading] = useState(true);
  const [itemCustomisation, setItemCustomisation] = useState([]);
  const originalCustomisation = useSelector(inRoomDiningCustomisationsSelector);
  useEffect(() => {
    if (selectedItem.customisation.status) {
      setItemCustomisation(selectedItem.customisation);
    }
    setLoading(false);
  }, [selectedItem]);

  const getCustomisationForIngredient = (customisationsForIngredient) => {
    const customisationArray = originalCustomisation?.filter((customisation) => {
      return customisationsForIngredient?.includes(customisation?.id);
    });
    return (
      <div className='row d-inline-flex'>
        {customisationArray
          ?.map((item) => {
            return item?.name;
          })
          ?.join(', ')}
      </div>
    );
  };

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : selectedItem &&
        selectedItem?.customisation?.status &&
        itemCustomisation?.ingredients?.length > 0 ? (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-12'>
              <div className='details-label mb-2'>Customisation</div>
              {itemCustomisation.ingredients.map((customisationIngredient, index) => (
                <>
                  <div className='details-value row d-flex mb-1' key={index}>
                    <div>
                      <span style={{ marginRight: '2%' }}>
                        {customisationIngredient.ingredient}:{' '}
                      </span>
                      {getCustomisationForIngredient(customisationIngredient.customisations)}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>No Customisation Available</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemViewCustomisation;
